/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import FabricCanvasTool from "../fabrictool"


class AddNote extends FabricCanvasTool {
  configureCanvas() {
    const canvas = this._canvas
    canvas.isDrawingMode = canvas.selection = false
    canvas.defaultCursor = 'default'
  }

  doMouseDown(o) {}

  doMouseMove(o) {}

  doMouseUp(o) {}
}

export default AddNote
